import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { CreateUserAccountParameter, getCreateUserAccount } from "@TKCCP/Services/tkccpCreateUserAccountService";
import { CreateUserAccountModel } from "@TKCCP/Types/ApiModels";

type UserAccountParameter = {
    onError?: (error: string) => void;
} & CreateUserAccountParameter &
    HasOnSuccess<CreateUserAccountModel>;

type HandlerType = ApiHandler<UserAccountParameter, CreateUserAccountModel>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getCreateUserAccount(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);

    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const loadUserAccountDetails = createHandlerChainRunner(chain, "LoadUserAccountDetails");
export default loadUserAccountDetails;
